import styled from "styled-components";
import { CSSVars } from "../../styles/styles.config";

export const StyledDiv = styled.div`
	margin: 0 auto;

	padding: 50px 0;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 80px 0;

		.platforms-container {
			padding: 0 40px;
		}
	}

	@media screen and (max-width: 800px) {
		.search-wrapper {
			overflow: hidden;
		}

		.plugin-wrapper {
			display: none;
		}
	}

	.search-components {
		width: 100%;
		max-width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		.search-wrapper {
			position: absolute;
			max-width: 440px;
			width: 90%;
			margin: 0 auto;
			display: block;
			z-index: 1;

			&::before {
				content: '';
				background: linear-gradient(
					90deg,
					rgba(245, 245, 245, 0) 0%,
					white 10%,
					white 90%,
					rgba(255, 255, 255, 0) 100%
				);
				position: absolute;
				top: -25%;
				left: -40%;

				height: 150%;
				width: 180%;
			}
		}
	}

	.platforms-container {
		max-width: 1280px;
		margin: 75px auto 0;
		padding: 0 20px;

		display: grid;

		grid-gap: 50px;
		grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
		grid-auto-rows: minmax(auto, 150px);

		&:has(.no-items) {
			color: ${CSSVars.black};
			display: flex;
			align-items: center;
		}

		.no-items {
			min-width: 100%;
			display: flex;
			flex-direction: column;
			gap: 30px;
			align-items: center;
			margin: 0 auto;

			p {
				font-size: 16px;
				padding-left: 20px;
			}

			img {
				max-width: 200px;
			}
		}

		.platform-card {
			background-color: ${CSSVars.white};
			display: flex;
			justify-content: center;
			padding: 50px;
			border-radius: 10px;
			transition: 0.2s;
			border: 1px solid ${CSSVars.gray50};

			&:hover {
				border: 1px solid ${CSSVars.gray100};
			}

			.img-wrapper {
				img {
					max-width: 100%;
					height: 100%;
					object-fit: contain;
					position: relative !important;
				}
			}
		}
	}
`;
